import React, {useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';

import {AuthModal} from "../AuthModal";
import {SignUpData, SignUpFirstStep} from "./elements/SignUpFirstStep";
import {SignUpConfirmStep} from "./elements/SignUpConfirmStep";
import {getInviteInfoFromLink} from "../../../../../actions/invite";
import {getTeamFromURL} from "../../../../../utils/url";


import {SignUpByLink} from '../SignUpByLink';
import {RequestAccessHint} from "./elements/RequestAccessHint";

export const SignUp = observer(() => {
    const [isBackVisible, setShowBack] = useState(false);
    const [step, setStep] = useState(1);
    const [stepData, setStepData] = useState<SignUpData | undefined>(undefined);

    const handleClose = useCallback(() => {}, []);

    const renderStep = () => {
        switch (step) {
            case 2:
                return <SignUpConfirmStep setStep={setStep} stepData={stepData} setShowBack={setShowBack}/>;
            default:
            case 1:
                return <SignUpFirstStep/>
        }
    }

    const inviteInfo = getInviteInfoFromLink();
    const teamSlug = getTeamFromURL();
    const isTeamSignupWithoutInvite = Boolean(teamSlug && teamSlug !== 'sign-up' && !inviteInfo);

    if (inviteInfo) {
        return (
            <SignUpByLink />
        );
    } else if (isTeamSignupWithoutInvite) {
        return (
            <AuthModal
                isOpen={true}
                onClose={handleClose}
                isBackVisible={isBackVisible}
            >
                <RequestAccessHint teamSlug={teamSlug}/>
            </AuthModal>
        );
    } else {
        return (
            <AuthModal
                isOpen={true}
                onClose={handleClose}
                isBackVisible={isBackVisible}
            >
                {renderStep()}
            </AuthModal>
        );
    }
})
